export const PERMISSION_KEYS = {
  // user's callcenter permissions
  CC_SUPERADMIN: "callcenter.isSuperAdmin",
  CC_ADMIN: "callcenter.isAdmin",
  CC_HAS_OKTELL_USERNAME: "callcenter.oktellUserName",
  CC_COMPANIES_WORKFLOW: "callcenter.acquiring",
  CC_INDIVIDUALS_WORKFLOW: "callcenter.emission",
  CC_VIEW_CARDS: "callcenter.cards",
  CC_BLOCK_CARD: "callcenter.blockCard",
  CC_ACTIVATE_CARD: "callcenter.activateCard",
  CC_SET_CARD_PIN_FOR_CHANGE: "callcenter.setCardForPinChange",
  CC_RESET_CARD_PIN_COUNTER: "callcenter.resetCardPinCounter",
  CC_CHANGE_CARD_NOTIFICATION_STATUS: "callcenter.changeCardNotificationStatus",
  CC_CHANGE_CARD_PHONE: "callcenter.changeCardPhone",
  CC_VIEW_CARD_LIMITS: "callcenter.cardLimits",
  CC_CHANGE_CARD_LIMITS: "callcenter.changeCardLimits",
  CC_VIEW_CARD_TRANSACTIONS: "callcenter.cardTransactions",
  // user's processing permissions
  PR_SUPERADMIN: "processing.isSuperAdmin",
  PR_ADMIN: "processing.isAdmin",
  PR_HAS_PROCESSING_USERNAME: "processing.processingUserName",
  PR_VIEW_COMPANIES: "processing.companies",
  PR_VIEW_MERCHANTS: "processing.merchants",
  PR_VIEW_TERMINALS: "processing.terminals",
  PR_VIEW_TRANSACTIONS: "processing.transactions",
  // user's admin permissions
  PR_VIEW_SSO_USERS: "processing.ssoUsers",
  PR_CREATE_SSO_USERS: "processing.createSsoUsers",
  PR_VIEW_PROCESSING_USERS: "processing.processingUsers",
  PR_CREATE_PROCESSING_USERS: "processing.createProcessingUsers",
  PR_DELETE_PROCESSING_USERS: "processing.deleteProcessingUsers",
  PR_BLOCK_PROCESSING_USERS: "processing.blockProcessingUsers",
  PR_CHANGE_PROCESSING_USER_ROLES: "processing.changeProcessingUserRoles",
  PR_CHANGE_PROCESSING_USER_ACCESS: "processing.changeProcessingUserAccess",
  // service desk permissions
  SD_SUPERADMIN: "serviceDesk.isSuperAdmin",
  SD_ADMIN: "serviceDesk.isAdmin",
  SD_HAS_SERVICE_DESK_USERNAME: "serviceDesk.serviceDeskUserName",

  // NOTE: ******* stated as not required in project
  // dynamic callcenter client based permissions
  // CLIENT_CONTACT_NUMBER_CALL: "CLIENT_CONTACT_NUMBER_CALL",
  // CLIENT_BACKUP_NUMBER_CALL: "CLIENT_BACKUP_NUMBER_CALL",
  // CLIENT_STANDARD_AUTH: "CLIENT_STANDARD_AUTH",
  // CLIENT_FULL_AUTH: "CLIENT_FULL_AUTH",
  // CLIENT_EXTENDED_AUTH: "CLIENT_EXTENDED_AUTH",
};

export const LOCK_KEYS = {
  CALLCENTER_WORKFLOW_ACCESS: "Доступ к интерфейсу коллцентра",
  PROCESSING_WORKFLOW_ACCESS: "Доступ к интерфейсу процессинга",
  ADMIN_WORKFLOW_ACCESS: "Доступ к административному интерфейсу",
  //
  FINANCIAL_INFO_INDIVIDUALS: "Финансовая информация по физ. лицам",
  FINANCIAL_INFO_COMPANIES: "Финансовая информация по юр. лицам",
  CARD_ISSUING_STATUS: "Готовность и выдача карты",
  CLIENT_ISSUES: "Обращение и претензия",
  CONTACT_NUMBER_CHANGE: "Изменение контактного мобильного номера телефона",
  CLIENT_INFO_CHANGE:
    "Изменение паспортных данных, адреса, дополнительного номера телефона, адреса электронной почты",
  // callcenter card keys
  CARD_ACTIVATION: "Активация карты",
  CARD_BLOCK: "Блокировка карты",
  CARD_UNBLOCK: "Разблокировка карты",
  CARD_PIN_CHANGE: "Установка ПИН-кода",
  CARD_PIN_COUNTER_RESET: "Сброс попыток неверного ввода ПИН-кода",
  CARD_PHONE_CHANGE: "Изменение телефона по карте",
  CARD_SMS_NOTIFICATIONS_SWITCH: "Включение/выключение sms информирования",
  CARD_REISSUE: "Перевыпуск карты",
  CARD_LIMITS_VIEW: "Просмотр лимитов, транзакционных схем",
  CARD_LIMITS_CHANGE: "Изменение лимитов, транзакционных схем",
  CARD_3DS_CHANGE: "Подключение/Отключение 3DS",
  CARD_TRANSACTIONS_VIEW: "Запрос выписки/Справки по операциям",
  CARD_TRANSACTION_CANCEL: "Отмена неуспешной авторизации",
  CARD_MONITORING_WHITELIST:
    "Внесение карты в white list для системы мониторинга",
};

export const PERMISSIONS_CONFIG = {
  // user's callcenter permissions
  [PERMISSION_KEYS.CC_SUPERADMIN]: {
    label: "Суперадмин колцентра",
  },
  [PERMISSION_KEYS.CC_ADMIN]: {
    label: "Админ колцентра",
  },
  [PERMISSION_KEYS.CC_HAS_OKTELL_USERNAME]: {
    label: "Привязян к пользователю oktell",
  },
  [PERMISSION_KEYS.CC_COMPANIES_WORKFLOW]: {
    label: "Телефония: доступ к работе с компаниями",
  },
  [PERMISSION_KEYS.CC_INDIVIDUALS_WORKFLOW]: {
    label: "Телефония: доступ к работе с физ. лицами",
  },
  [PERMISSION_KEYS.CC_VIEW_CARDS]: {
    label: "Доступ к просмотру банковских карт",
  },
  [PERMISSION_KEYS.CC_BLOCK_CARD]: {
    label: "Доступ к блокировке банковских карт",
  },
  [PERMISSION_KEYS.CC_ACTIVATE_CARD]: {
    label: "Доступ к разблокировке банковских карт",
  },
  [PERMISSION_KEYS.CC_SET_CARD_PIN_FOR_CHANGE]: {
    label: "Доступ к переводу на IVR для смены пинкода",
  },
  [PERMISSION_KEYS.CC_RESET_CARD_PIN_COUNTER]: {
    label: "Доступ к сбросу счетчика пинкодов",
  },
  [PERMISSION_KEYS.CC_CHANGE_CARD_NOTIFICATION_STATUS]: {
    label: "Доступ к изменению статуса нотификаций по картам",
  },
  [PERMISSION_KEYS.CC_CHANGE_CARD_PHONE]: {
    label: "Доступ к изменению телефона для нотификаций по карте",
  },
  [PERMISSION_KEYS.CC_VIEW_CARD_LIMITS]: {
    label: "Доступ к просмотру лимитов по картам",
  },
  [PERMISSION_KEYS.CC_CHANGE_CARD_LIMITS]: {
    label: "Доступ к изменению лимитов по картам",
  },
  [PERMISSION_KEYS.CC_VIEW_CARD_TRANSACTIONS]: {
    label: "Доступ к просмотру транзакций по картам",
  },
  // user's processing permissions
  [PERMISSION_KEYS.PR_SUPERADMIN]: {
    label: "Суперадмин процессинга",
  },
  [PERMISSION_KEYS.PR_ADMIN]: {
    label: "Админ процессинга",
  },
  [PERMISSION_KEYS.PR_HAS_PROCESSING_USERNAME]: {
    label: "Привязян к processing_username",
  },
  [PERMISSION_KEYS.PR_VIEW_COMPANIES]: {
    label: "Доступ к просмотру компаний",
  },
  [PERMISSION_KEYS.PR_VIEW_MERCHANTS]: {
    label: "Доступ к просмотру точек обслуживания",
  },
  [PERMISSION_KEYS.PR_VIEW_TERMINALS]: {
    label: "Доступ к просмотру терминалов",
  },
  [PERMISSION_KEYS.PR_VIEW_TRANSACTIONS]: {
    label: "Доступ к просмотру компаний",
  },
  // user's admin permissions
  [PERMISSION_KEYS.PR_VIEW_SSO_USERS]: {
    label: "Доступ к просмотру пользователей SSO",
  },
  [PERMISSION_KEYS.PR_CREATE_SSO_USERS]: {
    label: "Доступ к созданию пользователей SSO",
  },
  [PERMISSION_KEYS.PR_VIEW_PROCESSING_USERS]: {
    label: "Доступ к просмотру пользователей процессинга",
  },
  [PERMISSION_KEYS.PR_CREATE_PROCESSING_USERS]: {
    label: "Доступ к созданию пользователей процессинга",
  },
  [PERMISSION_KEYS.PR_DELETE_PROCESSING_USERS]: {
    label: "Доступ к удалению пользователей процессинга",
  },
  [PERMISSION_KEYS.PR_BLOCK_PROCESSING_USERS]: {
    label: "Доступ к блокировке пользователей процессинга",
  },
  [PERMISSION_KEYS.PR_CHANGE_PROCESSING_USER_ROLES]: {
    label: "Доступ к изменению ролей для пользователей процессинга",
  },
  [PERMISSION_KEYS.PR_CHANGE_PROCESSING_USER_ACCESS]: {
    label: "Доступ к изменению доступов для пользователей процессинга",
  },
  // service desk permissions
  [PERMISSION_KEYS.SD_SUPERADMIN]: {
    label: "Суперадмин service desk",
  },
  [PERMISSION_KEYS.SD_ADMIN]: {
    label: "Админ service desk",
  },
  [PERMISSION_KEYS.SD_HAS_SERVICE_DESK_USERNAME]: {
    label: "Оператор привязан к имени пользователя в service desk",
  },
  // callcenter per client permissions
  // ******* NOTE: stated as not required in project
  // [PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL]: {
  //   label: "Звонок с контактного номера",
  // },
  // [PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL]: {
  //   label: "Звонок с дополнительного номера",
  // },
  // [PERMISSION_KEYS.CLIENT_STANDARD_AUTH]: {
  //   label: "Стандартная авторизация",
  //   revokes: [
  //     PERMISSION_KEYS.CLIENT_FULL_AUTH,
  //     PERMISSION_KEYS.CLIENT_EXTENDED_AUTH,
  //   ],
  // },
  // [PERMISSION_KEYS.CLIENT_FULL_AUTH]: {
  //   label: "Полная авторизация",
  //   grants: [PERMISSION_KEYS.CLIENT_STANDARD_AUTH],
  //   revokes: [PERMISSION_KEYS.CLIENT_EXTENDED_AUTH],
  // },
  // [PERMISSION_KEYS.CLIENT_EXTENDED_AUTH]: {
  //   label: "Расширенная авторизация",
  //   grants: [
  //     PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
  //     PERMISSION_KEYS.CLIENT_FULL_AUTH,
  //   ],
  // },
};

export const LOCKS_CONFIG = {
  // front page locks
  [LOCK_KEYS.CALLCENTER_WORKFLOW_ACCESS]: {
    requirements: [
      [
        PERMISSION_KEYS.CC_COMPANIES_WORKFLOW,
        PERMISSION_KEYS.CC_INDIVIDUALS_WORKFLOW,
      ],
    ],
  },
  [LOCK_KEYS.PROCESSING_WORKFLOW_ACCESS]: {
    requirements: [
      [PERMISSION_KEYS.PR_VIEW_COMPANIES],
      [PERMISSION_KEYS.PR_VIEW_MERCHANTS],
      [PERMISSION_KEYS.PR_VIEW_TERMINALS],
      [PERMISSION_KEYS.PR_VIEW_TRANSACTIONS],
    ],
  },
  [LOCK_KEYS.ADMIN_WORKFLOW_ACCESS]: {
    requirements: [
      [PERMISSION_KEYS.PR_ADMIN],
      [PERMISSION_KEYS.CC_ADMIN],
      [PERMISSION_KEYS.SD_ADMIN],
      [PERMISSION_KEYS.PR_SUPERADMIN],
      [PERMISSION_KEYS.CC_SUPERADMIN],
      [PERMISSION_KEYS.SD_SUPERADMIN],
    ],
  },
  // callcenter locks

  // consultation
  [LOCK_KEYS.FINANCIAL_INFO_INDIVIDUALS]: {
    requirements: [
      [PERMISSION_KEYS.CC_VIEW_CARDS],
      [PERMISSION_KEYS.CC_VIEW_CARD_TRANSACTIONS],
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [
      //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [PERMISSION_KEYS.CLIENT_FULL_AUTH],
    ],
  },
  [LOCK_KEYS.FINANCIAL_INFO_COMPANIES]: {
    requirements: [
      [PERMISSION_KEYS.CC_COMPANIES_WORKFLOW],
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [
      //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [PERMISSION_KEYS.CLIENT_FULL_AUTH],
    ],
  },
  [LOCK_KEYS.CARD_ISSUING_STATUS]: {
    requirements: [
      [PERMISSION_KEYS.CLIENT_FULL_AUTH],
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [
      //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [PERMISSION_KEYS.CLIENT_FULL_AUTH],
    ],
  },
  [LOCK_KEYS.CLIENT_ISSUES]: {
    requirements: [
      [PERMISSION_KEYS.SD_HAS_SERVICE_DESK_USERNAME],
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [
      //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [PERMISSION_KEYS.CLIENT_FULL_AUTH],
    ],
  },

  // client data modification
  // NOT IMPLEMENTED
  [LOCK_KEYS.CONTACT_NUMBER_CHANGE]: {
    requirements: [
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [
      //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_FULL_AUTH,
      // ],
      // [PERMISSION_KEYS.CLIENT_EXTENDED_AUTH],
    ],
  },
  // NOT IMPLEMENTED
  [LOCK_KEYS.CLIENT_INFO_CHANGE]: {
    requirements: [
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // // redundant
      // // [
      // //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      // //   PERMISSION_KEYS.CLIENT_FULL_AUTH,
      // // ],
      // [PERMISSION_KEYS.CLIENT_FULL_AUTH],
    ],
  },

  // client card modification actions

  [LOCK_KEYS.CARD_PHONE_CHANGE]: {
    requirements: [
      [PERMISSION_KEYS.CC_CHANGE_CARD_PHONE],
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [
      //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_FULL_AUTH,
      // ],
    ],
  },
  [LOCK_KEYS.CARD_SMS_NOTIFICATIONS_SWITCH]: {
    requirements: [
      [PERMISSION_KEYS.CC_CHANGE_CARD_NOTIFICATION_STATUS],
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [
      //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_FULL_AUTH,
      // ],
    ],
  },
  [LOCK_KEYS.CARD_ACTIVATION]: {
    requirements: [
      [PERMISSION_KEYS.CC_ACTIVATE_CARD],
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [
      //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_FULL_AUTH,
      // ],
    ],
  },
  [LOCK_KEYS.CARD_BLOCK]: {
    requirements: [
      [PERMISSION_KEYS.CC_BLOCK_CARD],
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // // redundant
      // // [
      // //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      // //   PERMISSION_KEYS.CLIENT_FULL_AUTH,
      // // ],
      // [PERMISSION_KEYS.CLIENT_FULL_AUTH],
    ],
  },
  [LOCK_KEYS.CARD_UNBLOCK]: {
    requirements: [
      [PERMISSION_KEYS.CC_ACTIVATE_CARD],
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [
      //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_FULL_AUTH,
      // ],
    ],
  },
  [LOCK_KEYS.CARD_PIN_CHANGE]: {
    requirements: [
      [
        PERMISSION_KEYS.CC_SET_CARD_PIN_FOR_CHANGE,
        PERMISSION_KEYS.CC_HAS_OKTELL_USERNAME,
      ],
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [
      //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_FULL_AUTH,
      // ],
    ],
  },
  [LOCK_KEYS.CARD_PIN_COUNTER_RESET]: {
    requirements: [
      [PERMISSION_KEYS.CC_RESET_CARD_PIN_COUNTER],
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [
      //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_FULL_AUTH,
      // ],
      // [PERMISSION_KEYS.CLIENT_EXTENDED_AUTH],
    ],
  },
  // NOT IMPLEMENTED
  [LOCK_KEYS.CARD_REISSUE]: {
    requirements: [
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [
      //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_FULL_AUTH,
      // ],
    ],
  },

  // client card actions

  [LOCK_KEYS.CARD_LIMITS_VIEW]: {
    requirements: [
      [PERMISSION_KEYS.CC_VIEW_CARD_LIMITS],
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [
      //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_FULL_AUTH,
      // ],
      // [PERMISSION_KEYS.CLIENT_EXTENDED_AUTH],
    ],
  },
  [LOCK_KEYS.CARD_LIMITS_CHANGE]: {
    requirements: [
      [PERMISSION_KEYS.CC_VIEW_CARD_LIMITS],
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [
      //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_FULL_AUTH,
      // ],
      // [PERMISSION_KEYS.CLIENT_EXTENDED_AUTH],
    ],
  },
  // NOT IMPLEMENTED
  [LOCK_KEYS.CARD_3DS_CHANGE]: {
    requirements: [
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [
      //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_FULL_AUTH,
      // ],
    ],
  },
  [LOCK_KEYS.CARD_TRANSACTIONS_VIEW]: {
    requirements: [
      [PERMISSION_KEYS.CC_VIEW_CARD_TRANSACTIONS],
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [
      //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_FULL_AUTH,
      // ],
      // [PERMISSION_KEYS.CLIENT_EXTENDED_AUTH],
    ],
  },
  // NOT IMPLEMENTED
  [LOCK_KEYS.CARD_TRANSACTION_CANCEL]: {
    requirements: [
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [
      //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_FULL_AUTH,
      // ],
      // [PERMISSION_KEYS.CLIENT_EXTENDED_AUTH],
    ],
  },
  // NOT IMPLEMENTED
  [LOCK_KEYS.CARD_MONITORING_WHITELIST]: {
    requirements: [
      // [
      //   PERMISSION_KEYS.CLIENT_CONTACT_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_STANDARD_AUTH,
      // ],
      // [
      //   PERMISSION_KEYS.CLIENT_BACKUP_NUMBER_CALL,
      //   PERMISSION_KEYS.CLIENT_FULL_AUTH,
      // ],
      // [PERMISSION_KEYS.CLIENT_EXTENDED_AUTH],
    ],
  },
};



// WEBPACK FOOTER //
// ./src/accessConfig.js